import React from "react";
import Balancer from "react-wrap-balancer";
import { Box, Flex } from "@chakra-ui/react";
import { Section } from "components/section";
import { BookDemoButton, SignupButton } from "components/event-tracking";
import { negativeHorizontalContainerPadding } from "ui/container";
import { TextTitle } from "ui/text";
import { FadeIn } from "ui/animations";
import { UseCaseSlider } from "./slider";
import { AuraAnimation } from "./aura";

type HomeHeroProps = {
  title: string;
  description: string;
};

export function HomeHero({ title, description }: HomeHeroProps) {
  return (
    <Box pos="relative" overflow="hidden">
      <Section fullWidth bg="new.green.950" themeBgColor="new.green.950" theme="dark" py={0}>
        <Box pos="relative" boxSize="100%" pt={{ base: "bigger", md: "huger" }} pb="huge">
          <AuraAnimation />

          <FadeIn>
            <TextTitle
              theme="dark"
              size="2xl"
              align="center"
              descriptionMaxW="860px"
              pb={{ base: "huge", md: "huger", lg: "hugest" }}
              title={<Balancer>{title}</Balancer>}
              titleAs="h1"
              description={description}
              actions={
                <>
                  <SignupButton variant="secondary" />
                  <BookDemoButton />
                </>
              }
            />
          </FadeIn>
        </Box>

        <UseCaseSlider />
      </Section>

      <Section fullWidth my={0}>
        <Box bg="white" pos="absolute" left={-40} right={-40} bottom="0" h="240px" filter="blur(80px)" />
        <Box bg="white" pos="absolute" left={-40} right={-40} bottom="0" h="200px" filter="blur(30px)" />
        <Flex bg="white" h="hugest" flex={1} mx={negativeHorizontalContainerPadding} />
      </Section>
    </Box>
  );
}
